import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { SpinnerIcon } from '@sistemiv/s-components'
import { useAuth } from '../hooks/useAuth'

interface Props {
  children: React.ReactNode
}

const PrivateRoute: React.FC<Props> = ({ children }) => {
  const navigate = useNavigate()
  const { pathname } = useLocation()

  const { session, loading } = useAuth()
  const isEmailVerified = session?.identity?.verifiable_addresses?.some((addr) => addr.verified === true)

  React.useEffect(() => {
    if (session && !isEmailVerified && pathname !== '/verification') {
      navigate('/verification')
    }
  }, [session, isEmailVerified, navigate, pathname])

  if (loading) {
    return (
      <div className='w-full flex justify-center pt-5 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 absolute'>
        <SpinnerIcon className='text-sky-500 h-7 w-7' />
      </div>
    )
  }

  if (!session) return null

  return <>{children}</>
}

export default PrivateRoute
